module.exports = __webpack_public_path__ + "media/images/flags/16/Aruba-2ea3100dfa21f52cbe7d067874275039.png";